import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppHeaderComponent } from './app-header.component';
import { AppNavModule } from '../nav/nav.module';
import { LoginModule } from '../login/login.module';
import { AppRootService } from 'app/shared/services/app-root/app-root-service';
import { ClickOutsideModule } from 'libraries/ui_clickOutside/clickOutside.module';
import { AppHeaderTitleModule } from '../app-header-title/app-header-title.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { TabNavigationModule } from 'libraries/component/tab-navigation/tab-navigation.module';
import { PermissionModule } from 'libraries/permission/permission.module';
import { Mock4allModule } from "libraries/mock4all/mock4all.module";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { DummyCheckboxModule } from "libraries/dummyCheckbox/dummyCheckbox.module";
import { IsTruelyModule } from "libraries/pipes/is-truely/is-truely.module";
import { AppHeaderUserComponent } from "./app-header-user/app-header-user.component";
import { PopupMenuModule } from "../../../../libraries/component/popup-menu/popup-menu.module";
import { TravellerDataTranslationService } from 'libraries/service/traveller-data-translation/traveller-data-translation.service';
import { LabelService } from 'libraries/service/label/label.service';

@NgModule({
    imports: [
        AppNavModule,
        RouterModule,
        LoginModule,
        CommonModule,
        ClickOutsideModule,
        AppHeaderTitleModule,
        TabNavigationModule,
        BtnModule,
        PermissionModule,
        Mock4allModule,
        DummyCheckboxModule,
        ConfigurationResourceModule,
        IsTruelyModule,
        PopupMenuModule,
    ],
    exports: [
        AppHeaderComponent,
    ],
    declarations: [
        AppHeaderComponent,
        AppHeaderUserComponent
    ],
    providers: [
        AppRootService,
        TravellerDataTranslationService,
        LabelService 
    ],
})
export class AppHeaderModule { }
